export default {
  activity: {},
  layoutId: null,
  isPristine: true,
  formValues: {},
  formErrors: {},
  fieldValues: {},
  fieldErrors: {},
  selectedProspect: {},
  selectedOpportunity: {},
  selectedStage: {},
  selectedTask: {},
};



// WEBPACK FOOTER //
// ./~/vue-components/activity-summary/store/state.js